import { createAction, props } from '@ngrx/store'
import { DashboardInfoAPIModel } from 'src/models/api.model'

const prefix = '[dashboard]'

export const FETCH_DASHBOARD_INFO = createAction(`${prefix} FETCH_DASHBOARD_INFO`)

export const FETCH_DASHBOARD_INFO_SUCCESS = createAction(
  `${prefix} FETCH_DASHBOARD_INFO_SUCCESS`,
  props<{ dashboardInfo: DashboardInfoAPIModel }>()
)
